import { lower } from './search-text'

// QueryParser.cs, line for line. Whitespace (space, tab, CR, LF) separates
// tokens and runs of it collapse; every token is lower-cased. Double quotes
// wrap one literal token, inner spaces kept, that matches as an exact
// substring only; an unterminated quote runs to the end. Curly double quotes
// (“ ”) are quotes; curly single quotes (‘ ’) are apostrophes.
//
// A token is { text, quoted }.
export const parseQuery = query => {
  const tokens = []
  if (!query) return tokens

  let buf = ''
  let inQuote = false

  for (let i = 0; i < query.length; i++) {
    let c = query[i]
    if (c === '“' || c === '”') c = '"'

    if (c === '"') {
      if (inQuote) {
        if (buf.length > 0) {
          tokens.push({ text: lower(buf), quoted: true })
          buf = ''
        }
        inQuote = false
      } else {
        if (buf.length > 0) {
          tokens.push({ text: lower(buf), quoted: false })
          buf = ''
        }
        inQuote = true
      }
      continue
    }

    if (!inQuote && (c === ' ' || c === '\t' || c === '\n' || c === '\r')) {
      if (buf.length > 0) {
        tokens.push({ text: lower(buf), quoted: false })
        buf = ''
      }
      continue
    }

    buf += c
  }

  if (buf.length > 0) tokens.push({ text: lower(buf), quoted: inQuote })

  return tokens
}
